import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { Card, Col, Row, Typography } from "antd";
import React from 'react';
import FaIcon from "../Icons/FaIcon";
const { Title, Text } = Typography;

const ChangeInstancesWidget = ({ data }: { data: any }) => {
    return (
        <Card bordered={false} className="criclebox">
            <Row>
            <Title style={{ marginBottom: '16px' }} level={5}>Change Instances</Title>
            <div className="icon-box">{FaIcon(faCogs)}</div>
            </Row>
            <div className="number">
                <Row align="middle" gutter={[24, 0]}>
                    <Col xs={8}>
                        <span>Pending</span>
                        <Title level={3}>
                            {data?.cis_pending ?? 0}
                        </Title>
                    </Col>
                    <Col xs={8}>
                        <span>Completed</span>
                        <Title level={3}>
                            {data?.cis_completed ?? 0}
                        </Title>
                    </Col>
                    <Col xs={8}>
                        <span>Approved</span>
                        <Title level={3}>
                            {data?.cis_approved ?? 0}
                        </Title>
                    </Col>
                </Row>
            </div>
        </Card>
    )
}

export default ChangeInstancesWidget